var React = require('react');
var mui = require('material-ui');
var LogoTitle = require('./LogoTitle');

module.exports = React.createClass({
  displayName: 'Header',

  render: function() {
    return (
      <mui.AppBar
        zDepth={2}
        title={(
          <div className="container">
            <LogoTitle/>
          </div>
        )}
        showMenuIconButton={false}
      />
    );
  }

});



// WEBPACK FOOTER //
// ./src/components/Header.js